import { message } from 'antd';
import axios from 'axios';
import { publishService } from '../../utils/publish-subject';
import {
  ADD_FORM_FAIL,
  ADD_FORM_SUCCESS,
  CLEAR_FORM_ERROR,
  CONVERT_GFORM_FAIL,
  CONVERT_GFORM_LOADING,
  CONVERT_GFORM_SUCCESS,
  DELETE_FORM_FAIL,
  DELETE_FORM_LOADING,
  DELETE_FORM_SUCCESS,
  EDIT_FORM_FAIL,
  EDIT_FORM_LOADING,
  EDIT_FORM_SUCCESS,
  GET_FORM_FAIL,
  GET_FORM_LOADING,
  GET_FORM_SUCCESS,
  GET_FORMS_FAIL,
  GET_FORMS_LOADING,
  GET_FORMS_SUCCESS,
  GET_GOOGLE_FORMS_FAIL,
  GET_GOOGLE_FORMS_LOADING,
  GET_GOOGLE_FORMS_SUCCESS,
  PUBLISH_FORM_FAIL,
  PUBLISH_FORM_LOADING,
  PUBLISH_FORM_SUCCESS,
  UPDATE_QUESTION_FAIL,
  UPDATE_QUESTION_LOADING,
  UPDATE_QUESTION_SUCCESS,
} from '../types';

import NProgress from 'nprogress';

NProgress.configure({ showSpinner: false });

export const getForms = () => async (dispatch) => {
  dispatch({
    type: GET_FORMS_LOADING,
  });
  try {
    const response = await axios.get('/api/forms');

    dispatch({
      type: GET_FORMS_SUCCESS,
      payload: { forms: response.data.forms },
    });
  } catch (err) {
    dispatch({
      type: GET_FORMS_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const getForm = (id) => async (dispatch) => {
  dispatch({
    type: GET_FORM_LOADING,
  });
  try {
    const response = await axios.get(`/api/forms/${id}`);

    dispatch({
      type: GET_FORM_SUCCESS,
      payload: { message: response.data.form },
    });
  } catch (err) {
    dispatch({
      type: GET_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
    throw err;
  }
};

export const getGoogleForms = () => async (dispatch) => {
  dispatch({
    type: GET_GOOGLE_FORMS_LOADING,
  });
  try {
    const response = await axios.get('/api/forms/google');

    dispatch({
      type: GET_GOOGLE_FORMS_SUCCESS,
      payload: { forms: response.data.forms },
    });
  } catch (err) {
    dispatch({
      type: GET_GOOGLE_FORMS_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const addForm = (formData) => async (dispatch) => {
  try {
    const response = await axios.post('/api/forms/', formData);

    dispatch({
      type: ADD_FORM_SUCCESS,
      payload: { message: response.data },
    });

    return response.data;
  } catch (err) {
    dispatch({
      type: ADD_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};
export const addFormFromTemplate = (formData) => async (dispatch) => {
  try {
    const response = await axios.post('/api/forms/template', formData);

    dispatch({
      type: ADD_FORM_SUCCESS,
      payload: { message: response.data },
    });

    return response.data;
  } catch (err) {
    dispatch({
      type: ADD_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const duplicateForm = (formData) => async (dispatch) => {
  try {
    const response = await axios.post('/api/forms/template?copy=true', formData);

    dispatch({
      type: ADD_FORM_SUCCESS,
      payload: { message: response.data },
    });

    return response.data;
  } catch (err) {
    dispatch({
      type: ADD_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
    throw new Error(err.message);
  }
};

export const deleteForm = (id) => async (dispatch) => {
  dispatch({
    type: DELETE_FORM_LOADING,
    payload: { id },
  });
  try {
    await axios.delete(`/api/forms/${id}`);

    dispatch({
      type: DELETE_FORM_SUCCESS,
      payload: { message: id },
    });
  } catch (err) {
    dispatch({
      type: DELETE_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const editFormSettings = (id, formData) => async (dispatch) => {
  dispatch({
    type: EDIT_FORM_LOADING,
    payload: { id },
  });
  try {
    const response = await axios.patch(`/api/forms/${id}`, formData);

    return dispatch({
      type: EDIT_FORM_SUCCESS,
      payload: { message: response.data.form },
    });
  } catch (err) {
    return dispatch({
      type: EDIT_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message, id },
    });
  }
};

export const saveUpdates = (id, formQuestions) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_QUESTION_LOADING,
      payload: { id },
    });

    NProgress.start();

    const response = await axios.patch(`/api/forms/${id}/question`, { formQuestions });
    const form = response.data.form;

    dispatch({
      type: UPDATE_QUESTION_SUCCESS,
    });

    publishService.sendMessage(true);
  } catch (err) {
    dispatch({
      type: UPDATE_QUESTION_FAIL,
      payload: { error: err?.response?.data.message || err.message, id },
    });
    // TODO Add error messages for saveUpdates failure cases
    throw err;
  } finally {
    NProgress.done();
  }
};

export const convertGoogleForm = (id, formId) => async (dispatch) => {
  try {
    dispatch({ type: CONVERT_GFORM_LOADING });
    const response = await axios.patch(`/api/forms/${id}/convert`, null, {
      params: {
        formId,
      },
    });

    return dispatch({
      type: CONVERT_GFORM_SUCCESS,
      payload: { message: response.data.form },
    });
  } catch (err) {
    return dispatch({
      type: CONVERT_GFORM_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const publishForm = (id) => async (dispatch) => {
  dispatch({
    type: PUBLISH_FORM_LOADING,
    payload: { id },
  });
  try {
    const response = await axios.get(`/api/forms/${id}/publish`);

    dispatch({
      type: PUBLISH_FORM_SUCCESS,
      payload: { message: response.data.form },
    });
    message.success('Your WhatsForm is published! 🎉');
    return publishService.sendMessage(false);
  } catch (err) {
    dispatch({
      type: PUBLISH_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message, id },
    });
  }
};

export const restoreForm = (id) => async (dispatch) => {
  dispatch({
    type: PUBLISH_FORM_LOADING,
    payload: { id },
  });
  try {
    const response = await axios.get(`/api/forms/${id}/restore`);

    dispatch({
      type: PUBLISH_FORM_SUCCESS,
      payload: { message: response.data.form },
    });
    return publishService.sendMessage(false);
  } catch (err) {
    dispatch({
      type: PUBLISH_FORM_FAIL,
      payload: { error: err?.response?.data.message || err.message, id },
    });
  }
};

export const testWebhookEndpoint = async (axiosConfig) => {
  await axios.post('/integration/webhook/test', axiosConfig);
};

export const clearFormError = (id) => ({
  type: CLEAR_FORM_ERROR,
  payload: { id },
});
